import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDynamicReducerSelector } from '@core/js/components/common/ChangeForm/store';
import { validationCallbackCreator } from './helpers';

export const useSwissFormatValidation = () => {
    const fields = useDynamicReducerSelector(prop('fields'));

    const getPasswordOrTextTarget = useCallback(({ key }) => ({
        name: key['name'],
        value: '',
        errorMessage: ''
    }), []);

    const getRequiredTarget = useCallback(() => ({
        name: 'requiresConfirmation',
        value: '',
        errorMessage: ''
    }), []);

    return useCallback(() => validationCallbackCreator(fields, getPasswordOrTextTarget, getRequiredTarget), [
        fields, getPasswordOrTextTarget, getRequiredTarget
    ]);
};
